exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-image[data-v-7ed30882]{width:100%;height:500px}", ""]);

// exports
